var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazyload",class:{'img-responsive' : _vm.isImgResponsive},attrs:{"data-sizes":"auto","src":_vm.loading,"data-src":_vm.src,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }